import { Button, Col, Form, Input, Modal, Row, Select } from "antd";
import { useEffect } from "react";
import { postData, putData } from "../../../apiServices/common";

const FinishingLineModal = ({
  isModalOpen,
  closeModal,
  selectedRecord,
  isEdit,
  refetch,
  form,
}) => {
  useEffect(() => {
    if (isEdit && selectedRecord) {
      form.setFieldsValue({
        id: selectedRecord.id,
        name: selectedRecord.name,
        status: selectedRecord.status,
      });
    } else {
      form.resetFields();
      form.setFieldsValue({
        status: 1, // Default value for new records
      });
    }
  }, [isEdit, selectedRecord, form]);

  const handleSubmit = async (values) => {
    try {
      let response;
      if (isEdit) {
        response = await putData(
          `/api/digitalization/finishing-lines/${values.id}`,
          values,
        );
      } else {
        response = await postData(
          "/api/digitalization/finishing-lines",
          values,
        );
      }

      if (response && response.code === 200) {
        // message.success(
        //   `Finishing Line ${isEdit ? "updated" : "created"} successfully`,
        // );
        closeModal();
        refetch();
      } else {
        // message.error(
        //   `Error ${isEdit ? "updating" : "creating"} finishing line`,
        // );
      }
    } catch (error) {
      console.log("Error in FinishingLineModal:", error);
      // message.error(`Error ${isEdit ? "updating" : "creating"} finishing line`);
    }
  };

  return (
    <Modal
      open={isModalOpen}
      title={isEdit ? "Edit Finishing Line" : "Add Finishing Line"}
      onCancel={closeModal}
      footer={null}
      maskClosable
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{ status: 1 }}
      >
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>

        <Form.Item
          name="name"
          label="Line Name"
          rules={[{ required: true, message: "Please enter line name" }]}
        >
          <Input placeholder="Enter line name" />
        </Form.Item>

        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true, message: "Please select status" }]}
        >
          <Select>
            <Select.Option value={1}>Active</Select.Option>
            <Select.Option value={0}>Inactive</Select.Option>
          </Select>
        </Form.Item>

        <Row gutter={16}>
          <Col span={12}>
            <Button block onClick={closeModal}>
              Cancel
            </Button>
          </Col>
          <Col span={12}>
            <Button type="primary" htmlType="submit" block>
              {isEdit ? "Update" : "Save"}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default FinishingLineModal;
